import React from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { useForm, Controller } from "react-hook-form";

// Material-UI
import { Button, Container, Grid } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import UnduhIcon from "@material-ui/icons/GetAppRounded";
//Components
import NavbarUser from "../components/NavbarUser";
import Background from "../components/BackgroundPattern";
import TitlePage from "../components/TitlePageUser";
import TextPilih from "../components/TextPilih";
import Footer from "../components/Footer";
// Data
import DataMateriDiklat from "../data/DataMateriDiklat";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  section: {
    margin: theme.spacing(2, 0),
  },
  table: {
    minWidth: 700,
  },
  unduh: {
    width: 50,
    padding: theme.spacing(1),
  },
  bgWhite: {
    backgroundColor: "white"
  }
}));

const PilihMateri = ( {classes} ) => {
  const { handleSubmit, control } = useForm();
  const history = useHistory();
  const onSubmit = (data) => {
    if (data.pilihMateri !== "Diklat-1") {
      return Swal.fire({
        icon: "error",
        title: "Diklat Belum Dimulai",
        text: "Silahkan Pilih Diklat yang sedang dilaksanakan",
      });
    } else {
      return history.push('/user/materi-diklat/1')
    }
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={6} sm={6} md={5}>
            <FormControl className={classes.bgWhite} variant="outlined" margin="normal" required fullWidth>
              <InputLabel id="pilihMateriLabel">{"Pilih Materi"}</InputLabel>
              <Controller
                as={
                  <Select
                    labelId="pilihMateriLabel"
                    id="pilihMateri"
                    label="Pilih Materi"
                  >
                    <MenuItem value="">
                      <em>Pilih Materi Diklat</em>
                    </MenuItem>
                    <MenuItem value="Diklat-1">{"Diklat-1"}</MenuItem>
                    <MenuItem value="Diklat-2">{"Diklat-2"}</MenuItem>
                    <MenuItem value="Diklat-3">{"Diklat-3"}</MenuItem>
                    <MenuItem value="Diklat-4">{"Diklat-4"}</MenuItem>
                  </Select>
                }
                name="pilihMateri"
                control={control}
                defaultValue=""
                required
              />
            </FormControl>
          </Grid>
          <Grid item xs={5} sm={4} md={3}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              fullWidth
            >
              {"Pilih"}
            </Button>
          </Grid>
          <Grid item xs={1} sm={2} md={4}></Grid>
        </Grid>
      </form>
    </Container>
  );
};

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const TabelMateri = ({ classes }) => {
  const tableMateri = DataMateriDiklat.map((data) => (
    <StyledTableRow key={data.id}>
      <StyledTableCell component="th" align="justify">
        {data.namaMateri}
      </StyledTableCell>
      <StyledTableCell align="justify">{data.deskripsiMateri}</StyledTableCell>
      <StyledTableCell align="justify">
        <IconButton aria-label="download" className={classes.unduh}>
          <Link to={data.linkMateri} target="_blank">
            <UnduhIcon color="primary" />
          </Link>
        </IconButton>
      </StyledTableCell>
    </StyledTableRow>
  ));

  return (
    <Container className={classes.section} maxWidth="md">
      <TableContainer component={Paper} elevation={3}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="justify">{"Nama Materi"}</StyledTableCell>
              <StyledTableCell align="justify">{"Deskripsi"}</StyledTableCell>
              <StyledTableCell align="justify">{"Unduh"}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>{tableMateri}</TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

const UserMateriDiklatSatu = () => {
  const classes = useStyles();
  return (
    <section id="tabel-kehadiran" className={classes.container}>
      <Background/>
      <NavbarUser />
      <Container style={{flex: "1"}}>
        <TitlePage text="Materi Pendidikan dan Pelatihan (DIKLAT)" />
        <TextPilih text="Pilih Materi Diklat yang ingin diunduh"/>
        <PilihMateri classes={classes} />
        <TabelMateri classes={classes} />
      </Container>
      <Footer />
    </section>
  );
};

export default UserMateriDiklatSatu;
